module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/384.2d88ca82.png";